import { Box } from "@mui/material";
import { BerlinThemeProvider } from "@src/appV2/redesign/theme/ThemeProvider";
import { type ReactNode } from "react";

interface LegacyNavRedesignWrapperProps {
  children: ReactNode;
}

/**
 * Wraps a redesign component mounted inside the legacy `appLayout.tsx`
 * with `BerlinThemeProvider` (the redesign nav provides it automatically;
 * the legacy nav does not) and bounds the height to the viewport area
 * visible inside the legacy `<Content>` shell — viewport minus the antd
 * Layout.Header (64px), AppFooter (~70px), and the 24px vertical padding
 * `App.css` applies to `<main>` (24px top + 24px bottom = 48px). Sets up a
 * flex column with `minHeight: 0` so descendants can use `overflow` to
 * produce independently scrollable regions.
 *
 * Transitional — deleted with `appLayout.tsx` once the redesign flag is
 * removed.
 */
export function LegacyNavRedesignWrapper(props: LegacyNavRedesignWrapperProps) {
  const { children } = props;

  return (
    <Box
      sx={{
        height: "calc(100vh - 64px - 70px - 48px)",
        display: "flex",
        flexDirection: "column",
        minHeight: 0,
      }}
    >
      <BerlinThemeProvider fullHeight>{children}</BerlinThemeProvider>
    </Box>
  );
}
